import React from "react";
import image from '../../assets/image 6.png';

type Testimonial = {
    name: string;
    quote: string[];
    img: string;
    rating?: number;
};


const DATA: Testimonial[] = [
    {
        name: "Bob Smith",
        quote: [
            "I can't imagine working without it.",
            "Highly recommend!",
        ],
        img: image,
        rating: 5,
    },
    { ...this as any }
];
const Star = () => (
    <span className="material-icons text-[#F1C40F]">
        star
    </span>
);

export default function Testimonials() {
    const items = Array.from({ length: 4 }, () => DATA[0]);

    return (
        <section className="py-16">
            <div className="mx-auto max-w-[1150px] px-6">
                {/* Heading */}
                <h2 className="text-center text-[40px] font-bold">
                    Testimonials
                </h2>
                <p className="mt-3 text-center text-base text-black/60">
                    See what others are saying!
                </p>

                {/* Grid */}
                <div className="mt-10 grid gap-10 md:grid-cols-2">
                    {items.map((t, i) => (
                        <article
                            key={i}
                            className={[
                                "flex items-center gap-6",
                                "rounded-xl border border-black/10 bg-white",
                                "px-8 py-7",
                                "shadow-md shadow-black/25",
                            ].join(" ")}
                        >
                            {/* Avatar */}
                            <img
                                src={t.img}
                                alt={`${t.name} headshot`}
                                className="h-[140px] w-[140px] rounded-full object-cover"
                            />

                            {/* Text */}
                            <div className="flex-1">
                                <div className="flex items-center justify-between">
                                    <h3 className="text-[22px] font-semibold">{t.name}</h3>
                                    {/* rating */}
                                    <div className="flex items-center gap-1">
                                        {Array.from({ length: t.rating ?? 5 }).map((_, s) => (
                                            <Star key={s} />
                                        ))}
                                    </div>
                                </div>

                                <p className="mt-3 text-[15px] leading-6 text-black/70">
                                    {t.quote[0]} <br /> {t.quote[1]}
                                </p>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
